<button (click)="signInWithFB()" mat-button class="buttonColorFacebook">
    <img src="assets/images/fbImage.png" class="facebookImage" width="37px" alt="">
    &nbsp; 
    {{'keyword_$289' | translate}} {{'channel_keyword_$3' | translate}}
</button>
<br> <br>
<button (click)="signInWithGoogle()" align="center" mat-button class="buttonColorGoogle">
    <img src="assets/images/googleImage.png" class="googleImage" width="45px" alt="">
    &nbsp;
    <span class="googleText">{{'keyword_$289' | translate}} {{'channel_keyword_$15' | translate}}</span>
</button>
